<script>
import {VesselService} from "@/services/VesselService";
import { toBlob } from 'dom-to-image-more';

export default {
  name: "SummaryOnBoardCrewPieChart",
  data() {
    return {
      chartOptions: {
        plotOptions: {
          pie: {
            customScale: 1,
          }
        },
        chart: {
          type: 'pie',
          height: 1180,
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.selectedDataForModal = {
                full_data_index : config.dataPointIndex,
                data : this.series[config.dataPointIndex],
              };
              $('#summary_crew_onboard_modal').modal('show');
            },
          }
        },
        labels: this.labels,
        tooltip: {
          enabled: true,
          style : { color : '#fff' },
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize : '20px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
            colors: new Array(this.series.length).fill('#fff'),
          },
          background: {
            enabled: true,
            foreColor: '#000',
            padding: 4,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#fff',
            opacity: 0.9,
            dropShadow: { enabled: false }
          },
          dropShadow: { enabled: false },
          formatter: function(seriesName, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          }
        },
        legend: {
          height : 1180,
          position: 'left',
          fontFamily: 'Helvetica, Arial',
          fontWeight: 'bold',
          markers: {
            width: 8,
            height: 8,
            radius: 8,
            offsetX: -5,
          },
          formatter: function(seriesName, opts) {
            return seriesName + ": " + '<strong>' + opts.w.globals.series[opts.seriesIndex] + '</strong>';
          }
        },
      },
      selectedDataForModal : null
    }
  },
  computed: {
    summaryOnBoardCrewModalTableHeaders() {
      return [
        ...['ranks'],
        ...this.fullData.map(item => item.alias),
        ...['Total Crew (Per Rank)']
      ];
    }
  },
  methods : {
    async getGraphImage() {
      swal.fire({
        'title': `Exporting Summary Per Rank OnBoard`,
        'text': "Please wait...",
        'imageUrl': "https://img.icons8.com/color/400/pie-chart--v1.png",
        'imageWidth': 100,
        'imageHeight': 100,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()

      const blob = await toBlob(this.$refs["pie-chart-container"], {
        pixelRatio: 2,
        backgroundColor: 'white'
      });

      const formData = new FormData();
      formData.append("chart_image", blob, "chart.png");
      formData.append("report_type", 'Summary Per Rank OnBoard');

      const printResponse = await VesselService.printSummaryOfManagingVesselGraph(formData);
      swal.close()
      let url = window.URL.createObjectURL(new Blob([printResponse.data],{type:'application/pdf'}))
      let filename=`summary_onboard_crew_${Date.now()}.pdf`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        this.setPieContainerHeight()
      }, 100);
    },
    setPieContainerHeight() {
      setTimeout(() => {
        const pieChartContainer = $('#pie-chart-container');
        const foreignObjectElement = pieChartContainer.find('foreignObject');
        const foreignObjectDivHeight = foreignObjectElement.children('div').height();
        foreignObjectElement.css({
          height: foreignObjectDivHeight
        })
        pieChartContainer.find('svg').css({
          height: foreignObjectDivHeight
        })
      }, 300)
    }
  },
  props: {
    series: { type: Array, default: null },
    labels : { type : Array, default : null },
    legendPosition : { type : String, default : 'left' },
    fullData : { type : Array, default : [] }
  },
  mounted() {
    this.setPieContainerHeight();
    window.addEventListener("resize", this.setPieContainerHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setPieContainerHeight);
  },
}
</script>


<template>
  <div class="pie-chart-container" id="pie-chart-container" ref="pie-chart-container" style="height: 1180px">
    <apexchart
      ref="apex-chart-on-board-type"
      style="max-width: 100%; min-width: 100%"
      type="pie"
      height="auto"
      :options="chartOptions"
      :series="series.map(item => item.count)">
    </apexchart>

    <div class="modal fade" id="summary_crew_onboard_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-bordered mr-1">
                  <thead>
                  <tr>
                    <template v-for="header in summaryOnBoardCrewModalTableHeaders">
                      <template v-if="header === 'Total Crew (Per Rank)'">
                        <th class="text-center text-uppercase align-middle" style="background-color: #c9c9c9; border-bottom: 3px solid #b3b3b3; border-right: 1px solid #b3b3b3; border-left: 5px solid #676767; min-width: 105px;">{{ header }}</th>
                      </template>
                      <template v-else>
                        <th class="text-center text-uppercase align-middle" style="background-color: #e1e1e1; border: 1px solid #c3c3c3">{{ header }}</th>
                      </template>
                    </template>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th class="text-right text-uppercase white-space-no-wrap" style="background-color: #e1e1e1; border: 1px solid #c3c3c3; max-width: 500px;">{{selectedDataForModal?.data?.name}}</th>
                    <template v-for="(item, item_index) in selectedDataForModal?.data?.data">
                      <template v-if="item.total === 0">
                        <td class="text-center align-middle">{{item.total}}</td>
                      </template>
                      <template v-else>
                        <td class="text-center align-middle text-primary font-weight-bold" @click="$emit('showDataFromCms', fullData[item_index].totalOnboardCrewPerRank[selectedDataForModal.full_data_index], fullData[item_index], 'onboard')" style="cursor: pointer" title="Click to view crew list">
                          {{item.total}}
                        </td>
                      </template>
                    </template>
                    <td class="text-center align-middle" style="background-color: #c9c9c9; border-bottom: 1px solid #b3b3b3; border-right: 1px solid #b3b3b3; border-left: 5px solid #676767;">{{ selectedDataForModal?.data?.count }} </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
